import React from "react";

type FooterProps = {
  buttonType: string;
  onDeleteFilter: () => void;
  handleClearAll: () => void;
  handleSelectVarious: (items: string[]) => void;
  handleApply: () => void;
  type: string;
  defaultSelected: string[];
  hideApply: boolean;

  initialChecked: string[];
  secondaryButtonText: string;
};

export const Footer = ({
  buttonType,
  onDeleteFilter,
  handleClearAll,
  handleSelectVarious,
  handleApply,
  type,
  defaultSelected,
  hideApply,
  initialChecked,
  secondaryButtonText,
}: FooterProps) => {
  if (buttonType === "hidden") return null;

  return (
    <div className="flex justify-between bg-white p-2 border-t  bottom-0 w-full">
      {buttonType === "withDelete" && (
        <div className="w-full flex justify-start">
          <button onClick={onDeleteFilter}>Delete</button>
        </div>
      )}

      <div className="flex justify-between gap-3 w-full">
        <button
          onClick={() => {
            if (type === "select") {
              handleClearAll();
            } else {
              handleSelectVarious(initialChecked);
            }
          }}
        >
          {secondaryButtonText
            ? secondaryButtonText
            : (type && !type?.includes("filter")) ||
                defaultSelected?.length === 0
              ? "Clear"
              : "Undo"}
        </button>
        {!hideApply && (
          <button
            onClick={handleApply}
            className="text-sm bg-[#0E98D0] text-white px-2 py-1 rounded-sm"
          >
            Apply
          </button>
        )}
      </div>
    </div>
  );
};
